import { Directive, ElementRef, HostBinding, HostListener } from '@angular/core';


/**
 * TODO fixup focusing
 */
@Directive({
    // this directive will work only if the DOM el has the c_highlight class
    selector: '[appForceFocus]'
})
export class FocusDirective {

    @HostBinding('style.border') border = 'none';


    constructor(private elementRef: ElementRef) {

    }

    @HostListener('focus')
    onFocus() {
        this.border = '1px solid red';
    }

    @HostListener('blur')
    onBlur() {
        this.border = 'none';
    }
}
